import { render, staticRenderFns } from "./AddOnSelection.vue?vue&type=template&id=1b4b0781&"
import script from "./AddOnSelection.vue?vue&type=script&lang=ts&"
export * from "./AddOnSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports